/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSOURCEOFFUNDS = {
    Other: 'OTHER',
    BusinessIncome: 'BUSINC',
    SaleOfAssetOrProperty: 'SALE',
    CourtOrderOrSettlement: 'COURORD',
    TransferFromAnotherProvider: 'TRANSF',
    SalaryOrBonus: 'SALARY',
    Savings: 'SAVINGS',
    ProceedsOfExistingInvestment: 'INVEST',
    Inheritance: 'INHERIT',
    PensionFund: 'PENFUND',
    PreservationPensionFund: 'PREPNFN',
    PreservationProvidentFund: 'PREPRFN',
    ProvidentFund: 'PROFUND',
    Loan: 'LOAN',
    OverdraftFacilityAccount: 'OVFACC',
    TaxClearance: 'TAXCL',
    DivorceSettlement: 'DIVSETL',
    DistributionFromATrust: 'DISTRST',
    GiftOrDonation: 'GIFT'
} as const;
export type IAPSOURCEOFFUNDS = typeof IAPSOURCEOFFUNDS[keyof typeof IAPSOURCEOFFUNDS];


export function IAPSOURCEOFFUNDSFromJSON(json: any): IAPSOURCEOFFUNDS {
    return IAPSOURCEOFFUNDSFromJSONTyped(json, false);
}

export function IAPSOURCEOFFUNDSFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSOURCEOFFUNDS {
    return json as IAPSOURCEOFFUNDS;
}

export function IAPSOURCEOFFUNDSToJSON(value?: IAPSOURCEOFFUNDS | null): any {
    return value as any;
}

